import React from "react";
import RangeSlider from 'react-bootstrap-range-slider';

export default class SliderInput extends React.Component {

    constructor (props){
        super(props);

        this.timestamp = 0;
        this.state = {
            value: this.props.value
        }
    }

    render (){

        return ( 
        <div style={mainClass}>
            <div style={name}>{this.props.name}</div>
            <div style={{display: 'flex'}}>
                <RangeSlider
                          onMouseDown={() => alert("down")}
                          onMouseUp={() => alert("up")} 
                    value={this.state.value}
                    tooltip={'off'}
                    onAfterChange={changeEvent => {
                        this.props.onValueChange(changeEvent.target.value);
                    }}
                    onChange={changeEvent => {
                        this.setState({value: changeEvent.target.value});
                    }} />
                
                <div style={{marginLeft: '10px'}}>{this.state.value}</div>
            </div>
        </div>
        )
    }


}

const mainClass = {
    padding: '10px',
}

const name = {
    
}

const inputText = {
    width: '300px'
}